import React from 'react'

import {DayPeriod, StrengthTarget} from '../types'

import {StrengthTargetEmptyState} from './StrengthTargetEmptyState'
import {StrengthTargetList} from './StrengthTargetList'
import {StrengthTargetOverview} from './StrengthTargetOverview'

interface StrengthTargetContentAreaProps {
  selectedTab: DayPeriod | 'overview'
  targets: StrengthTarget[]
  targetsForSelectedDay: StrengthTarget[]
  hasTargetsForSelectedDay: boolean
  isReadOnly: boolean
  timezone: string
  onEditTarget: (target: StrengthTarget) => void
  onDeleteTarget: (target: StrengthTarget) => void
  onNewTarget: () => void
}

export const StrengthTargetContentArea: React.FC<StrengthTargetContentAreaProps> = ({
  selectedTab,
  targets,
  targetsForSelectedDay,
  hasTargetsForSelectedDay,
  isReadOnly,
  timezone,
  onEditTarget,
  onDeleteTarget,
  onNewTarget
}) => {
  if (selectedTab === 'overview') {
    return (
      <StrengthTargetOverview targets={targets} timezone={timezone} onEditTarget={onEditTarget} />
    )
  }

  if (hasTargetsForSelectedDay) {
    return (
      <StrengthTargetList
        targets={targetsForSelectedDay}
        dayPeriod={selectedTab}
        timezone={timezone}
        onEditTarget={onEditTarget}
        onDeleteTarget={onDeleteTarget}
        isReadOnly={isReadOnly}
      />
    )
  }

  return <StrengthTargetEmptyState onNewTarget={onNewTarget} isReadOnly={isReadOnly} />
}
